import { api } from "./api";

const KEY = "ccpa_opt_out";

export const readCcpaLocal = () => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } };

// Store the "Do Not Sell or Share" choice locally (honored by public/js/analytics.js) and re-apply tracking consent.
export function setCcpaLocal(on) {
  try { on ? localStorage.setItem(KEY, "1") : localStorage.removeItem(KEY); } catch { /* storage unavailable */ }
  try {
    const prefs = JSON.parse(localStorage.getItem("cookie_consent_preferences") || "null");
    if (typeof window.__applyCookieConsent === "function") window.__applyCookieConsent(prefs || { analytics: false });
  } catch { /* ignore */ }
}

export async function syncCcpaFromAccount() {
  try {
    const { data } = await api.get("/me/privacy-choices");
    if (data.ccpa_opt_out) setCcpaLocal(true);
    return data;
  } catch { return null; }
}
